import { ApiDisabilityKind, ApiDisabilityType } from '../api-types/disability-type.api';
import { ApiNeighborContext } from '../api-types/neighbor.api';
import { DisabilityKind, DisabilityType } from '../app-types/disability-type.app';
import { NeighborContext } from '../app-types/neighbors.app';
import {
	transformApiCategoryDiagnosesToAppCategoryDiagnoses,
	transformApiCategoryDiagnoseToAppCategoryDiagnose,
} from './category-diagnose.transform';
import { transformApiDocumentFilesToAppDocumentFiles } from './document.transform';
import { transformApiUserToAppUser } from './user.transform';

export const transformApiDisabilityTypesToAppDisabilityTypes = (input: ApiDisabilityType[]): DisabilityType[] => {
	return input.map((item) => transformApiDisabilityTypeToAppDisabilityType(item));
};

export const transformApiDisabilityTypeToAppDisabilityType = (item: ApiDisabilityType): DisabilityType => {
	return {
		id: item.id,
		remark: item.remark,
		categoryDiagnoses: transformApiCategoryDiagnosesToAppCategoryDiagnoses(item.categoryDiagnoses),
	};
};

export const transformApiDisabilityKindsToAppDisabilityKinds = (input: ApiDisabilityKind[]): DisabilityKind[] => {
	return input.map((item) => transformApiDisabilityKindToAppDisabilityKind(item));
};

export const transformApiDisabilityKindToAppDisabilityKind = (item: ApiDisabilityKind): DisabilityKind => {
	return {
		id: item.id,
		clientId: item.clientId,
		advisor: item.advisor ? transformApiUserToAppUser(item.advisor) : undefined,
		disabilityType: item.categoryDisabilityType
			? transformApiDisabilityTypeToAppDisabilityType(item.categoryDisabilityType)
			: undefined,
		documents: transformApiDocumentFilesToAppDocumentFiles(item.documents),
		categoryDiagnosis: item.categoryDiagnosis
			? transformApiCategoryDiagnoseToAppCategoryDiagnose(item.categoryDiagnosis)
			: undefined,
		statusAsOf: item.statusAsOf ? new Date(item.statusAsOf) : undefined,
		since: item.disabledSince,
		recoveredOn: item.recoveredOn ? new Date(item.recoveredOn) : undefined,
		remark: item.remark,
	};
};

export function transformApiDisabilityKindNeighborsToAppDisabilityKindNeighbors(
	input: ApiNeighborContext<ApiDisabilityKind>,
): NeighborContext<DisabilityKind> {
	return {
		current: transformApiDisabilityKindToAppDisabilityKind(input.current),
		previous: input.previous ? transformApiDisabilityKindToAppDisabilityKind(input.previous) : null,
		next: input.next ? transformApiDisabilityKindToAppDisabilityKind(input.next) : null,
	};
}
